import axios from "axios";
import { getAccessToken } from "../infrastructure/teams";

// NOTE: this client is currently used only for authorized endpoints
// (Excel file download from the API — see excelBlobDownload.service.ts), so it
// unconditionally attaches the Teams token. If public / outside-Teams requests
// appear in the future, split the public client from the authorized one instead
// of attaching a token to every request.
const service = axios.create();

service.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();
    config.headers.common["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
